import { useEffect } from "react";
import { Route, Redirect, Switch, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import Timer from "./pages/Timer";
import Landing from "./pages/Landing";
import SelectSquad from "./pages/SelectSquad";
import SignUp from "./pages/SignUp";
import SignUpTheater from "./pages/SignUpTheater";
import Share from "./pages/Share";
import YourScore from "./pages/YourScore";
import YourSquad from "./pages/YourSquad";

const Routes = () => {
  const location = useLocation();
  const { squadSubmission } = useSelector((state: any) => state);

  const CheckSubmissionRoute = ({ ...props }) => {
    return squadSubmission ? <Route {...props} /> : <Redirect to="/sign-up" />;
  };

  useEffect(() => {
    (window as any).analytics?.page();
  }, [location.pathname]);

  return (
    <Switch>
      <Route exact path="/" component={Landing} />
      <Route path="/sign-up" component={SignUp} />
      <Route path="/sign-up-theater" component={SignUpTheater} />
      <Route path="/select-squad" component={SelectSquad} />
      <CheckSubmissionRoute path="/timer" component={Timer} />
      <CheckSubmissionRoute path="/your-score" component={YourScore} />
      <CheckSubmissionRoute path="/your-squad" component={YourSquad} />
      <Route path="/share/:id" component={Share} />
      <Route path="/:id" component={Share} />
    </Switch>
  );
};

export default Routes;
